<template>
  <div class="flex w-full justify-between py-5">
    <div class="flex w-full items-center justify-between space-x-4">
      <div class="w-full flex-grow space-y-0.5">
        <p class="text-text-neutral-primary text-base font-semibold">
          {{ flightDirection }}
        </p>
        <p class="text-text-neutral-tertiary text-xs">
          {{ selectedBaggage?.title || $t('ancillaries.baggages.description') }}
        </p>
        <p
          v-if="selectedBaggage"
          v-price="selectedBaggage.price.amount"
          class="text-text-positive-primary text-xs font-medium"
        ></p>
        <p
          v-else-if="minPrice"
          class="text-text-positive-primary text-xs font-medium"
        >
          {{ $t('general.price.startFrom', { price: prettyPrice(minPrice) }) }}
        </p>
      </div>
      <FreeButton
        type="button"
        size="sm"
        class="w-full"
        :class="
          ancillariesState.isBaggagesSelected.value
            ? 'gray-button'
            : 'green-main-button'
        "
        @click="handleSelectButtonClick"
      >
        {{
          ancillariesState.isBaggagesSelected.value
            ? $t('general.delete')
            : $t('general.add')
        }}
      </FreeButton>
    </div>
    <BaggageBottomSheet
      :name="bottomSheetName"
      :baggage-list="ancillariesState.currentBaggages.value"
      :flight-direction="flightDirection"
      :total-price="ancillariesState.totalPrice.value"
      @onBaggageSave="saveBaggages"
      @onClose="ancillariesState.reset"
      @onBaggageChange="ancillariesState.changeBaggagesState"
    />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { FreeButton } from 'freedom-shared';
  import { v4 as uuid } from 'uuid';
  import { controllerModel } from 'shared';
  import { prettyPrice } from '@aviata/text-fns';

  import { mappedPassengersLib } from '@/entities/passenger-with-baggages';
  import type { ExtendedBaggage } from '@/entities/passenger-with-baggages';

  import { BaggageBottomSheet } from '../ui';
  import { useDraftBaggage } from '../model';

  const props = defineProps<{
    isBackSegment: boolean;
    flightDirection: string;
    baggages: ExtendedBaggage[];
    flightIdx: number;
  }>();

  const emit = defineEmits<{
    onBaggagesUpdate: [ancillariesPayload: ExtendedBaggage[]];
  }>();

  const bottomSheetName = uuid();
  const bottomSheet = controllerModel.useBottomSheet();

  const ancillariesState = computed(() => useDraftBaggage(props.baggages));
  const minPrice = computed(() =>
    mappedPassengersLib.getBaggageMinPrice(props.baggages),
  );
  const selectedBaggage = computed(() =>
    props.baggages.find(baggage => baggage.isSelected),
  );

  const saveBaggages = () => {
    emit('onBaggagesUpdate', ancillariesState.value.currentBaggages.value);
    bottomSheet.hide(bottomSheetName);
  };

  const handleSelectButtonClick = () => {
    if (ancillariesState.value.isBaggagesSelected.value) {
      ancillariesState.value.unselect();
      emit('onBaggagesUpdate', ancillariesState.value.currentBaggages.value);
    } else {
      bottomSheet.show(bottomSheetName);
    }
  };
</script>
